import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const createV2UsersMeOffHourSelector =
  cloudChiprApi.endpoints.postV2UsersMeOffHoursSchedules.select;
